<template>
<div class="label-row">
	<div class="col" v-for="field in fields">
		<p class="label-text">
			{{ field.title }}
		</p>
		<p>
			{{ $t( field.value ) }}
		</p>
	</div>
</div>
</template>

<script>
	export default {
		props: [
			'fields'
		]
	}
</script>